export default [
  {
    id: 0,
    name: 'total_mrr',
    description: 'Ingresos mensuales recurrentes totales obtenidos de las suscripciones.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'MRR',
    active: true
  },
  {
    id: 1,
    name: 'expansion_mrr',
    description: 'Adición a los ingresos recurrentes mensuales de las suscripciones existentes.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'MRR',
    active: true
  },
  {
    id: 2,
    name: 'new_mrr',
    description: 'Ingresos mensuales recurrentes obtenidos por nuevas suscripciones adquiridas durante el período.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'MRR',
    active: true
  },
  {
    id: 3,
    name: 'contraction_mrr',
    description: 'Disminución de los ingresos recurrentes mensuales de las suscripciones existentes.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        colors: ['#B71C1C'],
        backgroundColor: 'rgba(205, 92, 92, 0.2)',
        class: 'line'
      }
    },
    currency: true,
    category: 'MRR',
    active: true
  },
  {
    id: 4,
    name: 'churn_mrr',
    description: 'Ingresos mensuales recurrentes perdidos por cancelaciones durante el período.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'MRR',
    active: true
  },
  {
    id: 5,
    name: 'cancellation_mrr_by_plan',
    description: 'Ingresos mensuales recurrentes perdidos debido a cancelaciones durante el período por cada plan.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 6,
    name: 'net_growth_mrr',
    description: 'Aumento o disminución neto de los ingresos recurrentes mensuales durante el período.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        labels: ['Nuevo', 'Expansión', 'Contracción', 'Abandono', 'Crecimiento neto'],
        colors: ['#3F51B5', '#9FA8DA', '#FFECB3', '#FFC107', '#1A237E'],
        class: 'barStacked'
      }
    },
    currency: true,
    category: 'MRR',
    active: true
  },
  {
    id: 7,
    name: 'mrr_retention_cohort',
    description: 'Evolución de los ingresos mensuales recurrentes obtenidos de las suscripciones activas en un mes, durante un período de 12 meses.',
    type: [],
    category: '',
    active: false
  },
  {
    id: 8,
    name: 'Reactivación de MRR',
    description: 'Ingresos mensuales recurrentes obtenidos de suscripciones canceladas que se reactivan.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 9,
    name: 'arpu',
    description: 'Los ingresos promedio obtenidos por suscripciones por mes.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'Suscripciones',
    active: true
  },
  {
    id: 10,
    name: 'lifetime_value_of_a_subscription',
    description: 'Ingresos promedio generados por una suscripción paga durante su vida útil.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 11,
    name: 'Informe de movimiento del plan',
    description: 'Movimiento de suscripciones entre planes.',
    type: ['table'],
    category: '',
    active: false
  },
  {
    id: 12,
    name: 'abandonment_breakdown_report_by_record_date',
    description: 'Desglose del abandono durante el período especificado en varios intervalos de tiempo.',
    type: ['table'],
    category: '',
    active: false
  },
  {
    id: 13,
    name: 'total_mrr_by_plan',
    description: 'Ingresos mensuales recurrentes obtenidos de las suscripciones, segmentados por plan.',
    type: ['graph'],
    category: '',
    active: false
  },
  {
    id: 14,
    name: 'new_mrr_by_plan',
    description: 'MRR nuevo obtenido por suscripciones adquiridas durante el período segmentado por plan.',
    type: ['graph'],
    category: '',
    active: false
  },
  {
    id: 15,
    name: 'total_cancelled_subscription',
    description: 'Número total de cancelación de suscripciones hasta la fecha.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        colors: ['#B71C1C'],
        backgroundColor: 'rgba(205, 92, 92, 0.2)',
        class: 'line'
      }
    },
    currency: false,
    category: 'Suscripciones',
    active: true
  },
  {
    id: 16,
    name: 'Desglose de la suscripción',
    description: 'Desglose de las suscripciones de los últimos X meses en varios grupos, como upgrades, downgrades, cancelaciones, etc.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 17,
    name: 'total_cancelled_subscription',
    description: 'Número total de cancelaciones de suscripciones pagas durante el período especificado.',
    type: ['kpi', 'graph'],
    category: 'Suscripciones',
    active: false
  },
  {
    id: 18,
    name: 'Cancelación de suscripciones por plan',
    description: '',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 19,
    name: 'subscription_retention_cohort',
    description: 'Tasa de retención o recuento durante un período de 12 meses para las suscripciones activadas en un mes en particular.',
    type: [],
    category: '',
    active: false
  },
  {
    id: 20,
    name: 'rate_cancelled_subscription',
    description: 'Porcentaje de suscripciones canceladas durante el período.',
    type: {
      kpi: {
        displayComparative: true
      }
    },
    currency: false,
    category: 'Suscripciones',
    active: true
  },
  {
    id: 21,
    name: 'signups',
    description: 'Número total de inscripciones durante el período.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 22,
    name: 'total_billing',
    description: 'Valor total de las facturas generadas durante el período.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'Facturación',
    active: true
  },
  {
    id: 23,
    name: 'total_invoice_by_plan',
    description: 'Valor total de las facturas generadas por suscripciones durante el período segmentado por plan.',
    type: ['table'],
    category: '',
    active: false
  },
  {
    id: 24,
    name: 'Vida útil de la suscripción',
    description: 'Vida media de las suscripciones (en meses) antes de que se cancelen.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 25,
    name: 'Facturación nueva',
    description: 'Este es el valor total de las primeras facturas generadas a partir de suscripciones durante el período.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 26,
    name: 'total_billing_non_recurring',
    description: 'Ingresos no recurrentes totales facturados en un período en particular.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'Facturación',
    active: true
  },
  {
    id: 27,
    name: 'total_tax',
    description: 'Total de impuestos aplicados a las facturas durante el período de tiempo.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'Impuestos',
    active: true
  },
  {
    id: 28,
    name: 'total_cancelled_billing',
    description: 'Valor total de todas las facturas anuladas durante el período.',
    type: {
      kpi: {
        append: 'CLP',
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'Facturación',
    active: true
  },
  {
    id: 29,
    name: 'net_billing',
    description: 'Valor total de las facturas después de excluir el valor de las notas de crédito emitidas y los impuestos.',
    type: {
      kpi: {
        displayComparative: true
      },
      graph: {
        class: 'line'
      }
    },
    currency: true,
    category: 'Facturación',
    active: true
  },
  {
    id: 30,
    name: 'total_receivables_overdue',
    description: 'Total por cobrar de facturas que han superado la fecha de vencimiento del pago.',
    type: {
      kpi: {
        displayComparative: false
      }
    },
    currency: true,
    category: 'Cobranza',
    active: true
  },
  {
    id: 31,
    name: 'total_receivables_current_due',
    description: 'Total por cobrar de facturas que no han superado la fecha de vencimiento.',
    type: {
      kpi: {
        displayComparative: false
      }
    },
    currency: true,
    category: 'Cobranza',
    active: true
  },
  {
    id: 32,
    name: 'overdue_billing_recovery_breakdown',
    description: 'Agrupación de facturas no pagadas según el número de días vencidos.',
    type: {
      table: {
        headers: [
          { text: 'Días', value: 'label', class: 'font-weight-bold', sortable: false },
          { text: 'Número de facturas', value: 'data', class: 'font-weight-bold', sortable: false }
        ]
      }
    },
    currency: false,
    category: 'Cobranza',
    active: true
  },
  {
    id: 71,
    name: 'customer_debtor',
    description: 'Indice de clientes con mayor deuda.',
    type: {
      table: {
        headers: [
          { text: 'Cliente', value: 'label', class: 'font-weight-bold', sortable: false },
          { text: 'Número de facturas', value: 'count', class: 'font-weight-bold', align: 'end', sortable: false },
          { text: 'Deuda total (balance)', value: 'data', class: 'font-weight-bold', align: 'end', sortable: false }
        ],
        formats: {
          label: 'text',
          count: 'quantity',
          data: 'currency'
        },
        link: 'CustomerRetrieveUpdate'
      }
    },
    currency: false,
    category: 'Cobranza',
    active: true
  },
  {
    id: 32,
    name: 'Desglose de recuperación de facturas vencidas',
    description: 'Tabla que muestra las facturas que se pagaron después de la fecha de vencimiento, agrupadas por número de días que se tomó en pagar después de la fecha de vencimiento.',
    type: ['table'],
    category: '',
    active: false
  },
  {
    id: 34,
    name: 'Notas de crédito totales',
    description: 'Valor total de las notas de crédito emitidas durante el período.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 35,
    name: 'Fuga de ingresos por cupón de descuento',
    description: 'Desglose de la pérdida de ingresos por cada cupón de descuento.',
    type: ['graph'],
    category: '',
    active: false
  },
  {
    id: 36,
    name: 'Resumen de fugas de ingresos: cupones',
    description: 'Resumen de la cantidad de veces que se canjeó un cupón y el valor total que se le atribuyó.',
    type: ['table'],
    category: '',
    active: false
  },
  {
    name: 'Resumen de ingresos por complementos recurrentes',
    description: 'Desglose de los ingresos generados por complementos recurrentes.',
    type: ['table'],
    category: '',
    active: false
  },
  {
    id: 37,
    name: 'Resumen de ingresos por complementos',
    description: 'Desglose de los ingresos generados por complementos no recurrentes.',
    type: ['table'],
    category: '',
    active: false
  },
  {
    id: 38,
    name: 'Cancelación programada total de MRR ',
    description: 'MRR total de las suscripciones que están programadas para cancelarse (tienen un limite de periodos para ser cobradas).',
    type: ['table'],
    category: '',
    active: false
  },
  {
    id: 39,
    name: 'Cancelación programada total',
    description: 'Número total de suscripciones programadas para cancelarse en el futuro.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 40,
    name: 'Ingresos promedio por nueva suscripción',
    description: 'Ingresos promedio de una nueva suscripción en el período de tiempo especificado.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 41,
    name: 'Ingresos promedio por suscripción cancelada',
    description: 'Ingreso promedio perdido por suscripción cancelada en el período de tiempo especificado.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 42,
    name: 'Cantidad total de suscripciones',
    description: 'Número total de suscripción a partir de ahora.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 43,
    name: 'Clientes activos totales',
    description: '',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 44,
    name: 'Flujo de caja recurrente',
    description: 'Valor total de los pagos recibidos contra facturas recurrentes.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 45,
    name: 'Flujo de caja no recurrente',
    description: 'Valor total de los pagos recibidos contra facturas no recurrentes.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 46,
    name: 'Flujo de caja bruto',
    description: 'Total de pagos recurrentes y no recurrentes recibidos durante el período.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 47,
    name: 'Reembolsos',
    description: 'Valor total de los reembolsos realizados a los clientes durante el período.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 48,
    name: 'Reembolsos por Gateway',
    description: 'Valor total de los reembolsos realizados a los clientes durante el período, segmentado por pasarela de pagos.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 49,
    name: 'Reembolsos por método de pago',
    description: 'Valor total de los reembolsos realizados a los clientes durante el período, segmentado por método de pago.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 50,
    name: 'Número de transacciones de pago',
    description: 'Número total de transacciones de pago durante el período.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 51,
    name: 'Número de transacciones de reembolso',
    description: 'Número total de transacciones de reembolso durante el período.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 52,
    name: 'Flujo de caja bruto por Gateway',
    description: 'Valor total de los pagos recibidos durante el período segmentados por pasarela de pago.',
    type: ['graph'],
    category: '',
    active: false
  },
  {
    id: 53,
    name: 'Flujo de caja bruto por método de pago',
    description: 'Valor total de los pagos recibidos durante el período segmentados por método de pago.',
    type: ['graph'],
    category: '',
    active: false
  },
  {
    id: 54,
    name: 'Resumen de transacciones de pago',
    description: 'Un resumen de las transacciones de pago exitosas, fallidas, anuladas, en progreso y de tiempo de espera mes a mes.',
    type: ['graph'],
    category: '',
    active: false
  },
  {
    id: 55,
    name: 'Flujo de efectivo neto',
    description: 'Neto de flujo de caja bruto y reembolsos durante el período.',
    type: ['graph'],
    category: '',
    active: false
  },
  {
    id: 56,
    name: 'Resumen de transacciones de reembolso',
    description: 'Un resumen de las transacciones de reembolso exitosas, fallidas, anuladas, en curso y por tiempo de espera, mes a mes.',
    type: ['graph'],
    category: '',
    active: false
  },
  {
    id: 57,
    name: 'Número de transacciones de pago anuladas',
    description: 'Número total de transacciones de pago anuladas durante el período.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 58,
    name: 'Número de transacciones de pago fallidas por Gateway',
    description: 'Número total de transacciones de pago fallidas durante el período segmentadas por Gateway',
    type: ['graph'],
    category: '',
    active: false
  },
  {
    id: 59,
    name: 'Número de transacciones de pago fallidas por método de pago',
    description: 'Número total de transacciones de pago fallidas durante el período segmentadas por método de pago.',
    type: ['graph'],
    category: '',
    active: false
  },
  {
    id: 60,
    name: 'Número de transacciones de reembolso fallidas',
    description: 'Número total de transacciones de reembolso fallidas durante el período.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 61,
    name: 'Cantidad de suscripción por plan / complemento',
    description: '',
    type: ['graph'],
    category: '',
    active: false
  },
  {
    id: 62,
    name: 'MRR de suscripciones en pausa',
    description: 'Ingresos mensuales recurrentes de suscripciones en estado de pausa.',
    type: ['kpi', 'graph'],
    category: '',
    active: false
  },
  {
    id: 63,
    name: 'Tarjetas caducadas',
    description: 'Este es el número total de tarjetas de crédito que vencieron en los últimos seis meses.',
    type: ['table'],
    category: '',
    active: false
  },
  {
    id: 64,
    name: 'Tarjetas a punto de expirar',
    description: 'Este es el número total de tarjetas de crédito que vencerán en los siguientes seis meses.',
    type: ['table'],
    category: '',
    active: false
  },
  {
    id: 65,
    name: 'Cancelación de MRR por país',
    description: 'Ingresos mensuales recurrentes perdidos por cancelaciones durante el período segmentado por país.',
    type: ['graph'],
    category: '',
    active: false
  },
  {
    id: 66,
    name: 'Cantidad total de suscripción por plan',
    description: '',
    type: ['graph'],
    category: '',
    active: false
  },
  {
    id: 67,
    name: 'Resumen de impuestos por nombre de impuestos',
    description: '',
    type: ['table'],
    category: '',
    active: false
  },
  {
    id: 68,
    name: 'Resumen de errores de pagos',
    description: 'Número total de transacciones de error segmentadas por código de error mientras se procesa una transacción de pago.',
    type: ['table'],
    category: '',
    active: false
  },
  {
    id: 69,
    name: 'Resumen de errores de reembolsos',
    description: 'Número total de transacciones de error segmentadas por código de error mientras se procesa un reembolso.',
    type: ['table'],
    category: '',
    active: false
  },
  {
    id: 70,
    name: 'total_receivables',
    description: 'Total por cobrar de facturas no vencidas y vencidas.',
    type: {
      kpi: {
        displayComparative: false
      }
    },
    currency: true,
    category: 'Cobranza',
    active: true
  },
  {
    id: 72,
    name: 'total_payments',
    description: 'Total de transacciones exitosas recibidas.',
    type: {
      graph: {
        class: 'line',
        metrics: [
          { metric: 'single_payments', group: false, sum: true },
          { metric: 'recurrent_payments', group: false, sum: true }
        ]
      }
    },
    currency: true,
    category: 'Cobranza',
    active: true
  },
  {
    id: 73,
    name: 'transactions_received_by_gateway',
    description: 'Total de transacciones exitosas recibidas agrupadas por procesador de pagos.',
    type: {
      graph: {
        class: 'bar',
        colors: [
          { color: '#8e24aa', label: 'stripe' },
          { color: '#03A9F4', label: 'ach_transfer' },
          { color: '#009688', label: 'offline_payment' },
          { color: '#f06292', label: 'webpay' },
          { color: '#6d4c41', label: 'getnet' },
          { color: '#00acc1', label: 'mercadopago' },
          { color: '#b71c1c', label: 'getnetclick' },
          { color: '#00acc1', label: 'oneclick' },
          { color: '#3949ab', label: 'current' }
        ],
        metrics: [
          { metric: 'single_payments', group: true },
          { metric: 'recurrent_payments', group: true },
          { metric: 'single_payments', group: false, sum: true },
          { metric: 'recurrent_payments', group: false, sum: true }
        ],
        lastAsSum: true
      }
    },
    currency: true,
    category: 'Cobranza',
    active: true
  }
]
